import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { GeolocationService } from '../services/geolocationservice';
import { otpservice } from '../services/otpservice';
import { sweetalert } from "../services/sweetalert";
import { invalid } from '@angular/compiler/src/render3/view/util';
@Component({
  selector: 'app-qrlanding-home',
  templateUrl: './qrlanding-home.component.html',
  styleUrls: ['./qrlanding-home.component.css']
})
export class QrlandingHomeComponent implements OnInit {
  @ViewChild('input1', { static: false }) input1: ElementRef;
  
  formcheckclear: boolean = false;
  submitted = false;
  form: FormGroup = new FormGroup({});  
  otp: any;
  lang: any;
  lat: any;
  response: any;
  seqno: any;
  message: any;
  val: string;
  
  mobileNumber:any = "";
  show: boolean = true;
  enable :string;
  otpresponsemessage: any;
  otptabenable: string;

  otp1: any = null;
  otp2: any = null;
  otp3: any = null;
  otp4: any = null;
  otp5: any = null;
  otp6: any = null;

  keypressed: number;
  otpenable: string;
  otpenabled: boolean;
  c: string = "N";
  otpverified: boolean;
  resendenable: string;
  verifyenable: string;
  enableProceedBtnVerifyOtp: string;
  otperror: string;
  
  otpvalue: any;
  Statuscode: any;
  incorrect: string;
  msgotp: string;
  otpconsentdate: any;
  verifiedotp: boolean;
  otpnumber: any;

  verifiedotpclear: string = "";
  otpverifiedstatus: any;
  formSubmitted: boolean = false;
  otpNotEntered: boolean = false;
  hideVerifyBtn : false;
  redirectionPage: any;
  mobileNo: any;
  redirect: any;
  loanAmount: any;
  availableCardLimit: any;
  CustomerName:any;
  loader:boolean=false;
  
  responseData: any;
  dealercode: any;
  acceptTerms:boolean;
  formError: string;


  constructor(private activatedRoute: ActivatedRoute,private service: GeolocationService,private router: Router, private fb: FormBuilder,private httpClient: HttpClient,
    private otpservice: otpservice,private sweetalert: sweetalert, private datepipe: DatePipe
    ) {this.form = fb.group({  
      mobileNumber: ['', [Validators.required, Validators.pattern("^[6789]{1,1}[0-9]{9,9}$")]]  
      ,acceptTerm: [false,Validators.requiredTrue]}) 
    this.getLocation(); }

  ngOnInit(): void {
    this.loader = true;
    this.activatedRoute.queryParams.subscribe((params) => {
      this.dealercode = params["dealercode"] != null ? params["dealercode"].replaceAll("","") : null;
      if(this.dealercode==null){
        this.dealercode = params["dealerCode"] != null ? params["dealerCode"].replaceAll("","") : null;
      }
     console.log("dealercode:" + this.dealercode);
    localStorage.setItem("dealercode", this.dealercode);
    
     (error) => {
        this.loader = false;
        console.error("Unable to Process");
      };
      this.loader = false;
    });
  }


  toggleEditableotp(event) {

    this.submitted = true ;
    this.acceptTerms == this.form.value.acceptTerm;
    if(this.acceptTerms==undefined ){
      this.acceptTerms = false; 
    }
    console.log("accecpt Terms "+this.form.value.acceptTerm)
    console.log("mobile num"+this.form.value.mobileNumber)
    
    // if (this.form.value.mobileNumber==''){
    //   this.sweetalert.MSG_sweertalert("ENTER MOBILE NUMBER");
    //   return;
    // }
    // if(!this.form.valid){
    //   this.sweetalert.MSG_sweertalert("PLEASE FILL THE MANDATORY FIELS");
    //   return;
    // }
    // if (this.form.invalid){
    //   this.formError = 'ENTER FIELDS';
    //   return;
    // }
    if(this.form.valid){
    console.log("mobbbNumber"+this.mobileNumber)
    localStorage.setItem("mobilenum",this.mobileNumber)
    this.otpservice.getotp().then(data => {
      this.input1.nativeElement.focus();
      this.otpresponsemessage = this.otpservice.message;
      //this.data="OTP INITIATED. Valid upto 10 Minutes";
      this.otpenable = "disable";
      this.otptabenable = "none";
      this.resendenable = "none";
      this.verifyenable = "none";
      this.enableProceedBtnVerifyOtp = 'N';
      // this.proceedBtnDisabled=false;
    });
  }
    }
  keyPress(event: KeyboardEvent, textbox) {
    this.keypressed = event.keyCode;
    this.otpenabled = true;
    if (this.keypressed == 8) {
      if (textbox == 1) {
        document.getElementById("6-otp").focus();
      }
      if (textbox == 2) {
        document.getElementById("1-otp").focus();
      }
      if (textbox == 3) {
        document.getElementById("2-otp").focus();
      }
      if (textbox == 4) {
        document.getElementById("3-otp").focus();
      }
      if (textbox == 5) {
        document.getElementById("4-otp").focus();
      }
      if (textbox == 6) {
        if (this.c == "Y") {
          document.getElementById("5-otp").focus();
          this.c = "N";
        }
        if (this.c == "N") {
          this.otp6 = "";
          this.c = "Y"
        }
      }
      this.otpverified = true;
    }
  }
  getLocation(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const longitude = position.coords.longitude;
        const latitude = position.coords.latitude;
        this.lang = longitude;
        this.lat = latitude;

        localStorage.setItem("longitude", this.lang);
        localStorage.setItem("latitude", this.lat);

     console.log("lat"+this.lat)
     console.log("lang"+this.lang)
        // alert(localStorage.getItem("longitude"));
        //  this.callApi(longitude, latitude);
      });
    } else {
      console.log("No support for geolocation")
    }
  }
  otpdetails = this.fb.group({
    OTP1: ['', [Validators.required]],
    OTP2: ['', [Validators.required]],
    OTP3: ['', [Validators.required]],
    OTP4: ['', [Validators.required]],
    OTP5: ['', [Validators.required]],
    OTP6: ['', [Validators.required]],
    verifiedbox: ['']

  }, {
  }
  );


  get o() {
    return this.otpdetails.controls;
  }

  
  get f(){  
    return this.form.controls;  
  }  
  callVerifyOtpBtn(){ 
    if ((this.otpdetails.value.OTP1 <= "") || (this.otpdetails.value.OTP2 <= "") || (this.otpdetails.value.OTP3 <= "") || (this.otpdetails.value.OTP4 <= "") || (this.otpdetails.value.OTP5 <= "") || (this.otpdetails.value.OTP6 <= "")) {
      //this.loader = false;
      this.otperror = "*Enter Otp Accordingly In all the fields";
    } else {

      this.verify();
    
    }
  }
  verify() {
    this.submitted = true;
    this.otpNotEntered = false;
    this.loader = true;
    if ((this.otpdetails.value.OTP1 <= "") || (this.otpdetails.value.OTP2 <= "") || (this.otpdetails.value.OTP3 <= "") || (this.otpdetails.value.OTP4 <= "") || (this.otpdetails.value.OTP5 <= "") || (this.otpdetails.value.OTP6 <= "")) {
      this.loader = false;
      this.otperror = "*Enter Otp Accordingly In all the fields";
    }
    else {
      this.otpvalue = this.otpdetails.value.OTP1 +
        this.otpdetails.value.OTP2 +
        this.otpdetails.value.OTP3 +
        this.otpdetails.value.OTP4 +
        this.otpdetails.value.OTP5 +
        this.otpdetails.value.OTP6;
      this.otpservice.otp = this.otpvalue
      this.otpservice.verifyotp().then(data => {
        this.Statuscode = this.otpservice.statuscode
        if (this.Statuscode == "ER") {
         this.loader = false;
          this.otp1 = "";
          this.otp2 = "";
          this.otp3 = "";
          this.otp4 = "";
          this.otp5 = "";
          this.otp6 = "";
          this.otpresponsemessage = null;
          this.incorrect = "* Entered OTP is incorrect";
          this.otperror = ""
          this.sweetalert.UTP_sweertalert();
        }
        else if (this.Statuscode == "EX") {
         this.loader = false;
          this.otp1 = "";
          this.otp2 = "";
          this.otp3 = "";
          this.otp4 = "";
          this.otp5 = "";
          this.otp6 = "";
          this.otperror = "";
          this.otpresponsemessage = null;
          this.incorrect = "* Entered OTP is incorrect";
          this.msgotp = "Entered OTP is incorrect";
          this.sweetalert.errorsweertalert(this.msgotp);
        }
        else if (this.Statuscode == "SR") {
         this.loader = false;
          this.otpconsentdate = this.datepipe.transform(new Date(), 'yyyy/MM/dd');
          this.msgotp = "OTP Verified Successfully";
          this.sweetalert.success_sweertalert(this.msgotp);
          this.resendenable = "disable";
          this.verifyenable = "disable";
          this.otptabenable = "button-disable";
          this.otpresponsemessage = null;
          this.incorrect = "";
          this.verifiedotp = true;
          this.otpnumber = this.otpvalue;
          this.verifyinput(this.verifiedotp);
          this.enableProceedBtnVerifyOtp = 'Y';
          this.submit();
          // this.proceedBtnDisabled=true;
        }
      })
      //this.verifymessage = sessionStorage.getItem("verificationmessage");
    }
  }  
  verifyinput(val: any) {
    if (val) {
      this.verifiedotpclear = "Y";
      this.otpverifiedstatus = val;
    }
    else {
      this.otpverifiedstatus = false;
    }
    
  }
  submit(){
    
    this.formSubmitted = true;
    console.log(this.otpdetails)
    console.log(this.form.valid)
    console.log(this.otpdetails.valid)
    if (!this.form.valid || !this.otpdetails.valid) {
      if(!this.otpdetails.valid) {
        this.otpNotEntered = true;
      }
      this.sweetalert.Mandatory_sweertalert();
      return false;
    } else {
      
      // if(this.form.value.tandc == 'no' || this.form.value.emi == 'no') {
      //   if(this.form.value.tandc == 'no')
      //     this.errorMsg = "Please select Yes for Terms and Conditions";
      //   else
      //     this.errorMsg = "Please select Yes for monthly EMI being debited";
      //   this.sweetalert.errorsweertalert(this.errorMsg);
      //   return false;
      // }
      setTimeout(() => {
        if(!this.verifiedotp) {
          return false;
        }
        this.formSubmitted = false;
        this.otpNotEntered = false;

      //  this.insertData();
       this.service.getRedirectionPage(this.mobileNumber,this.dealercode).subscribe(
          (data: any) => {
            this.redirectionPage = JSON.parse(data?.data);
           if (typeof (data) === 'object') {
              console.log("event:" + JSON.stringify(data));
              
              this.redirectionPage = JSON.parse(data.data);
            this.redirect =  this.redirectionPage.REDIRECTION;
           this.loanAmount =  this.redirectionPage.LOAN_AMOUNT;
          this.availableCardLimit = this.redirectionPage.AVL_CRD_LIMIT;
          this.CustomerName = this.redirectionPage.CUSTOMER_NAME;
          localStorage.setItem("loanAmount", this.loanAmount);
        localStorage.setItem("availableCardLimit", this.availableCardLimit);
        localStorage.setItem("customerName", this.CustomerName); 
            console.log("redirectionPageeee"+this.redirect)
              console.log(JSON.stringify(this.redirectionPage))

            this.router.navigate([this.redirect]);   
            }
          });
    }, 1000);     
      }
  }

  resendotp() {
    // this.proceedBtnDisabled=false;
    this.enableProceedBtnVerifyOtp = 'N';
    this.otpservice.resendotp().then(data => {
      this.Statuscode = this.otpservice.resendstatus;
      if (this.Statuscode = "SR") {
        this.otpresponsemessage = this.otpservice.resendmessage;
        this.incorrect = null;
      }
    });
  }
  password() {
    this.show = !this.show;
  }

  ChangeNumber(){
    console.log("changenumber")
    this.form.reset();
    this.otpdetails.reset();
  
    let otpModel = document.getElementById("otpModel") as HTMLDivElement;
    otpModel.style.display = 'none';

  //   this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
  //     this.router.navigate(['qrLandingHome']);
  // }); 
    // this.router.navigate(['qrLandingHome']);
  }
  closeOtpModal(){
    let otpModel = document.getElementById("otpModel") as HTMLDivElement;
    otpModel.style.display = 'none';
    this.ChangeNumber()
  }

  

}
